import { useTranslation } from "react-i18next";

import type { WebhookRegistration } from "../api";
import { ClientWebhookConfiguration } from "./ClientWebhookConfiguration";
import { WebhookRegistrationCard } from "./WebhookRegistrationCard";

import Icons from "@/components/icons";
import { Button } from "@/components/ui/v2/button";
import { Card } from "@/components/ui/v2/card";

interface ClientWebhookComparisonProps {
  webhookId: string | null;
  webhookSecret: string | null;
  matchingRegistration: WebhookRegistration | null | undefined;
  onReregister: () => void;
  onDelete: (registrationId: string) => void;
  isReregistering: boolean;
  isDeleting: boolean;
}

export function ClientWebhookComparison({
  webhookId,
  webhookSecret,
  matchingRegistration,
  onReregister,
  onDelete,
  isReregistering,
  isDeleting,
}: ClientWebhookComparisonProps) {
  const { t } = useTranslation();

  if (!webhookId) {
    return null;
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <Card className="p-4">
        <ClientWebhookConfiguration 
          webhookId={webhookId}
          webhookSecret={webhookSecret}
          matchingRegistration={matchingRegistration ?? undefined}
        />
      </Card>

      <Card className="p-4">
        {matchingRegistration ? (
          <WebhookRegistrationCard
            registration={matchingRegistration}
            onDelete={onDelete}
            isDeleting={isDeleting}
          />
        ) : (
          <div className="flex items-center justify-center h-full">
            <Button
              variant="default"
              size="sm"
              onClick={onReregister}
              disabled={isReregistering}
            >
              <Icons.SyncIcon fontSize={16} className={isReregistering ? "animate-spin" : ""} />
              {t("webhooks.recruitnow.reregister")}
            </Button>
          </div>
        )}
      </Card>
    </div>
  );
}
